// eslint-disable-next-line no-restricted-syntax
import * as FCM_CONFIGS from '@change-corgi/fcm/configs';
import type { FcmConfig } from '@change-corgi/fcm/configs';
import type { FcmDetails } from '@change-corgi/fcm/details';
import { FCM_DETAILS } from '@change-corgi/fcm/details';

export type FcmAdminConfig = Omit<FcmConfig, 'merger'> &
	FcmDetails & {
		type: 'json' | 'number' | 'string' | 'boolean';
	};

export const FCM_ADMIN_CONFIGS = Object.values(FCM_CONFIGS).reduce<Record<string, FcmAdminConfig>>(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(acc, { normalizer, defaultValue, name }: FcmConfig<any, any>) => {
		if (!name) {
			// skipping default export
			return acc;
		}
		// eslint-disable-next-line no-param-reassign, @typescript-eslint/no-unsafe-assignment
		acc[name] = {
			name,
			normalizer,
			// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
			defaultValue,
			...FCM_DETAILS[name],
			// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
			type: (normalizer as any).type as 'number' | 'string' | 'boolean' | 'json',
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} as any;
		return acc;
	},
	{},
);

export function getFcmAdminConfig(name: string): FcmAdminConfig | undefined {
	return FCM_ADMIN_CONFIGS[name];
}
